<template>
  <div>
    <div class="locw" v-if="dailies.length!=0">
      <div style="width: 100%; height: 1rem;"></div>
      <recHead></recHead>

      <!--  <videoItem></videoItem>-->
      <!--  <articleItem></articleItem>-->
      <!--  <articleItem></articleItem>-->
      <!--  <articleItem></articleItem>-->

      <div v-for="(item, index) in dailies" @click="cliActItem(item.id)">
        <videoItem v-if="item.type==1" :key="index" :ref="`r${index}`" :baseObj="item" ></videoItem>
        <articleItem v-else :key="index" :ref="`r${index}`" :baseObj="item" ></articleItem>
      </div>

      <div style="width: 100%; height: 3rem"></div>
    </div>
  </div>

</template>

<script>
import recHead from "./recHead";
import videoItem from "./videoItem";
import articleItem from "./articleItem";
import {getWebRecommendDailies} from "../../js/shareApp/daily";
import {Toast} from "vant";
import {utils} from "../../network/utils";
import {app} from "../../network/app/app";
import {actConfig} from "../../js/activity/actConfig";
import {actUtil} from "../../js/activity/util";

export default {
  name: "homeRecommend",
  components:{
    recHead,
    videoItem,
    articleItem
  },
  data(){
    return {
      dailies: []
    }
  },
  mounted() {
    console.log('recommend mount')
  },
  created() {
    Toast.loading({
      duration: 5000, // 持续展示 toast
      forbidClick: true,
      message: '加载中...',
    });
    getWebRecommendDailies().then(res=>{
      // console.log('获取网页推荐动态');
      // console.log(res)

      if(typeof res.dailies != "undefined") {
        for (let i=0; i<res.dailies.length; i++){
          let retObj = this.getItem(res.dailies[i].daily)
          if(retObj!=null){
            this.dailies.push(retObj)
          }
        }
      }
      // console.log(this.dailies)

      Toast.clear()
    }).catch(err=>{
      Toast.clear()
      console.log('获取网页推荐动态 err***');
      console.log(err)
    })
  },
  methods:{
    cliActItem(id){
      // console.log(id)
//是否处于分享
      if(app.getState()){
        // this.$router.push({path: '/shareApp/shareDaily/'+id})
        //app内打开，打开新的页面跳转
        // app.gotoUri('shareApp/shareDaily/'+id)
      }else{
        this.$router.push({path: '/shareApp/shareDaily/'+id})
        // this.$router.replace({path: '/share/shareActPersonPage/vote1/'+actConfig.getData().activityId+'/'+item.userId})
      }
    },
    getItem(daily){
      let obj = {}
      obj.id = daily.id
      obj.title = daily.title
      obj.type = daily.type   //动态类型:0 文章 1 视频   (smallInteger)

      obj.goodNum = daily.goodNum //点赞数   (integer)
      obj.commentNum = daily.commentNum //评论数   (integer)
      obj.collectionNum = daily.collectionNum //收藏数   (integer)

      obj.imageCount = daily.imageCount ////图片数   (integer)
      obj.contentImage = JSON.parse(daily.contentImage) //图片内容包括视频预览图片 json数组   (text)
      obj.contentVideo = daily.contentVideo //视频内容  (string)

      obj.time = actUtil.remainingTime(daily.time)   //发布时间  (bigInteger)
      return obj
    },
  },
}
</script>

<style scoped>
.locw{
  width: 990px;
  margin: auto;
  color: #30353d;
}
</style>